import React from "react";
import "./HTML_MAIN_CSS.css";

const HTMLHead = () => {
  return (
    <div className="html-container">
      <h1>HTML – Head</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          The <code>&lt;head&gt;</code> element contains metadata and information about the HTML document. It can include the page title, links to stylesheets, scripts, meta information, and other resources. Content in the <code>&lt;head&gt;</code> is not displayed directly on the webpage.
        </p>
      </section>

      {/* 2. Common Elements */}
      <section id="common-elements">
        <h2>2. Common Elements Inside &lt;head&gt;</h2>
        <ul>
          <li><strong>&lt;title&gt;</strong> – Sets the page title.</li>
          <li><strong>&lt;meta&gt;</strong> – Provides metadata (charset, description, viewport, author, keywords).</li>
          <li><strong>&lt;link&gt;</strong> – Links external resources like CSS or favicon.</li>
          <li><strong>&lt;style&gt;</strong> – Internal CSS styles.</li>
          <li><strong>&lt;script&gt;</strong> – JavaScript code or external scripts.</li>
          <li><strong>&lt;base&gt;</strong> – Sets base URL for relative links.</li>
        </ul>
      </section>

      {/* 3. Example Head Section */}
      <section id="example">
        <h2>3. Example of a Head Section</h2>
        <pre>
          <code>{`<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="description" content="HTML Head Example">
    <title>My Web Page</title>
    <link rel="stylesheet" href="style.css">
    <link rel="icon" href="favicon.ico" type="image/x-icon">
    <script src="script.js" defer></script>
</head>`}</code>
        </pre>
      </section>

      {/* 4. Meta Tags */}
      <section id="meta-tags">
        <h2>4. Important Meta Tags</h2>
        <ul>
          <li><code>&lt;meta charset="UTF-8"&gt;</code> – Defines character encoding.</li>
          <li><code>&lt;meta name="viewport" content="width=device-width, initial-scale=1.0"&gt;</code> – Makes page responsive.</li>
          <li><code>&lt;meta name="description" content="..."/&gt;</code> – SEO description.</li>
          <li><code>&lt;meta name="keywords" content="HTML, CSS, JavaScript"/&gt;</code> – Search keywords.</li>
          <li><code>&lt;meta name="author" content="Your Name"/&gt;</code> – Author of the page.</li>
        </ul>
      </section>

      {/* 5. Linking Resources */}
      <section id="linking-resources">
        <h2>5. Linking External Resources</h2>
        <p>Examples of linking resources:</p>
        <pre>
          <code>{`<!-- CSS -->
<link rel="stylesheet" href="styles.css">

<!-- Favicon -->
<link rel="icon" href="favicon.ico" type="image/x-icon">`}</code>
        </pre>
      </section>

      {/* 6. Scripts in Head */}
      <section id="scripts">
        <h2>6. Scripts in Head</h2>
        <p>Include JavaScript using <code>&lt;script&gt;</code>:</p>
        <pre>
          <code>{`<!-- External script -->
<script src="app.js" defer></script>

<!-- Inline script -->
<script>
    console.log("Hello from the head!");
</script>`}</code>
        </pre>
        <p><strong>Tip:</strong> Use <code>defer</code> or <code>async</code> to avoid blocking page rendering.</p>
      </section>

      {/* 7. Summary */}
      <section id="summary">
        <h2>7. Summary</h2>
        <ul>
          <li>The <code>&lt;head&gt;</code> element contains metadata and resources.</li>
          <li>Use <code>&lt;title&gt;</code> to define the page title.</li>
          <li>Meta tags improve SEO, define encoding, and make pages responsive.</li>
          <li>Link stylesheets, favicons, and scripts using <code>&lt;link&gt;</code> and <code>&lt;script&gt;</code>.</li>
          <li>Content inside <code>&lt;head&gt;</code> is generally not displayed directly on the page.</li>
        </ul>
      </section>
    </div>
  );
};

export default HTMLHead;
